import { Amplify } from "aws-amplify";
import { createApolloClient, createCloudApolloClient } from "../graphql/client";
import { createAuthApi } from "./auth";
import {
  createShellHandleHost,
  type ShellHandleHost,
} from "./createShellHandle";
import type { ApolloClient } from "@apollo/client";

export interface BootstrapResult {
  host: ShellHandleHost;
  client: ApolloClient<unknown>;
  cloudClient: ApolloClient<unknown>;
}

export function bootstrapShellHost(): BootstrapResult {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_AWS_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_AWS_CLIENT_ID,
        identityPoolId: import.meta.env.VITE_AWS_IDENTITY_POOL_ID,
        loginWith: { username: true },
      },
    },
  });
  const auth = createAuthApi();
  const client = createApolloClient(auth);
  const cloudClient = createCloudApolloClient(auth);
  const host = createShellHandleHost(client, cloudClient);
  return { host, client, cloudClient };
}
